import { RelayPageDataTable } from "@constellation-academy/epic-ui";
import { useContext } from "react";
import { useTranslation } from "@i18n/hooks";
import { type reportsTable_DSAReportInlineFragment$key } from "@relay/reportsTable_DSAReportInlineFragment.graphql";
import { type reportsTable_QueryFragment$key } from "@relay/reportsTable_QueryFragment.graphql";
import { type reportsTable_QueryFragmentRefetch } from "@relay/reportsTable_QueryFragmentRefetch.graphql";
import { DSA_REPORT_INLINE_FRAGMENT, QUERY_FRAGMENT } from "./reports-table.graphql";
import { type ReportsTableProps } from "./reports-table.types";
import { CopyTableIdButton } from "../../../../components/copy-table-id-button";
import { DateTimeDisplay } from "../../../../components/datetime-display/datetime-display.component";
import { ReportsContext } from "../../reports.context";
import { ViewReportButton } from "../view-report-button";

export const ReportsTable = ({ reportsFragmentRef, canRead }: ReportsTableProps) => {
	const { t } = useTranslation("common");
	const { filters } = useContext(ReportsContext);

	const handleOnConnectionIdChange = () => {};
	return (
		<>
			<RelayPageDataTable<
				reportsTable_QueryFragmentRefetch,
				reportsTable_QueryFragment$key,
				reportsTable_DSAReportInlineFragment$key
			>
				queryFragment={QUERY_FRAGMENT}
				parentFragmentRef={reportsFragmentRef}
				nodeInlineFragment={DSA_REPORT_INLINE_FRAGMENT}
				extractConnection={(d) => d.Admin.Reports.Reports}
				rowsCount={20}
				filters={filters}
				onConnectionIdChange={handleOnConnectionIdChange}
				emptyMessage={t("reports.noReports")}
			>
				{(Column) => (
					<>
						<Column
							header={t("table.id")}
							body={(report) => (
								<CopyTableIdButton id={report.id}>
									<b>ID</b>
								</CopyTableIdButton>
							)}
						/>
						<Column
							header={t("reports.referenceNumber")}
							body={(report) => (
								<CopyTableIdButton id={report.referenceNumber}>
									{report.referenceNumber}
								</CopyTableIdButton>
							)}
						/>
						<Column
							header={t("reports.createdAt")}
							body={(report) => (
								<DateTimeDisplay value={report.createdAt} hideTimezone />
							)}
						/>

						{canRead && (
							<Column
								header={t("table.actions")}
								style={{ width: "20%" }}
								body={(report) => <ViewReportButton reportId={report.id} />}
							/>
						)}
					</>
				)}
			</RelayPageDataTable>
		</>
	);
};
